import styled from 'styled-components';

import { Text } from 'shared/components/Text/Text';
import { Link } from 'react-router-dom';

export const SubText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  display: inline;
`;
export const LinkStyled = styled(Link)`
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textLinkLinkSecondary2100};
  display: inline;
`;
export const WeakText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  word-break: break-all;
  display: inline;
`;
export const SubTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
  gap: 8px;
`;
